import MailsConfig from "./MailsConfig";

export default MailsConfig;